import { createSelector, createFeatureSelector } from '@ngrx/store';
import { RequestsState } from './requests.reducer';

export const selectRequestsState =
  createFeatureSelector<RequestsState>('requests');

// List selectors
export const selectRequests = createSelector(
  selectRequestsState,
  state => state.requests
);

export const selectRequestItems = createSelector(
  selectRequests,
  requests => requests?.items ?? []
);

export const selectRequestsLoading = createSelector(
  selectRequestsState,
  state => state.loading
);

export const selectRequestsError = createSelector(
  selectRequestsState,
  state => state.error
);

export const selectCurrentFilter = createSelector(
  selectRequestsState,
  state => state.currentFilter
);

export const selectTotalCount = createSelector(
  selectRequests,
  requests => requests?.totalCount ?? 0
);

export const selectTotalPages = createSelector(
  selectRequests,
  requests => requests?.totalPages ?? 0
);

export const selectCurrentPage = createSelector(
  selectRequests,
  requests => requests?.pageNumber ?? 1
);

export const selectPageSize = createSelector(
  selectRequests,
  requests => requests?.pageSize ?? 25
);

// Filter options selectors
export const selectFilterOptions = createSelector(
  selectRequestsState,
  state => state.filterOptions
);

export const selectFilterOptionsLoading = createSelector(
  selectRequestsState,
  state => state.filterOptionsLoading
);

// Request detail selectors
export const selectCurrentRequest = createSelector(
  selectRequestsState,
  state => state.currentRequest
);

export const selectCurrentRequestLoading = createSelector(
  selectRequestsState,
  state => state.currentRequestLoading
);

export const selectCurrentRequestError = createSelector(
  selectRequestsState,
  state => state.currentRequestError
);

export const selectCurrentRequestComments = createSelector(
  selectCurrentRequest,
  request => request?.comments ?? ''
);

export const selectCurrentRequestFileDetails = createSelector(
  selectCurrentRequest,
  request => request?.fileDetails ?? []
);

// Print locations selectors (for process modal)
export const selectPrintLocations = createSelector(
  selectRequestsState,
  state => state.printLocations
);

export const selectPrintLocationsLoading = createSelector(
  selectRequestsState,
  state => state.printLocationsLoading
);

// Print locations by site selectors (for request details)
export const selectPrintLocationsBySite = createSelector(
  selectRequestsState,
  state => state.printLocationsBySite
);

export const selectPrintLocationsBySiteLoading = createSelector(
  selectRequestsState,
  state => state.printLocationsBySiteLoading
);

// Update request selectors
export const selectUpdateRequestLoading = createSelector(
  selectRequestsState,
  state => state.updateRequestLoading
);

export const selectUpdateRequestError = createSelector(
  selectRequestsState,
  state => state.updateRequestError
);

// Process request selectors
export const selectProcessRequestLoading = createSelector(
  selectRequestsState,
  state => state.processRequestLoading
);

export const selectProcessRequestError = createSelector(
  selectRequestsState,
  state => state.processRequestError
);

export const selectProcessRequestResult = createSelector(
  selectRequestsState,
  state => state.processRequestResult
);

// User list selectors
export const selectUserList = createSelector(
  selectRequestsState,
  state => state.userList
);

export const selectUserListLoading = createSelector(
  selectRequestsState,
  state => state.userListLoading
);

// Request statuses selectors
export const selectRequestStatuses = createSelector(
  selectRequestsState,
  state => state.requestStatuses
);

export const selectRequestStatusesLoading = createSelector(
  selectRequestsState,
  state => state.requestStatusesLoading
);

// Print sites selectors
export const selectPrintSites = createSelector(
  selectRequestsState,
  state => state.printSites
);

export const selectPrintSitesLoading = createSelector(
  selectRequestsState,
  state => state.printSitesLoading
);

// Create request wizard selectors
export const selectCreateRequestLoading = createSelector(
  selectRequestsState,
  state => state.createRequestLoading
);

export const selectCreateRequestError = createSelector(
  selectRequestsState,
  state => state.createRequestError
);

export const selectCreatedRequestId = createSelector(
  selectRequestsState,
  state => state.createdRequestId
);
